export const COLOR = {
  error: 'error',
  inherit: 'inherit',
  info: 'info',
  link: 'link',
  primary: 'primary',
  inverse: 'inverse',
  secondary: 'secondary',
  success: 'success',
  tertiary: 'tertiary',
  warning: 'warning'
};
export const COLOR_MAP = {
  [COLOR.error]: 'om-type--ERROR',
  [COLOR.inherit]: 'om-type--INHERIT-COLOR',
  [COLOR.info]: 'om-type--INFO',
  [COLOR.link]: 'om-type--LINK',
  [COLOR.primary]: 'om-type--PRIMARY',
  [COLOR.secondary]: 'om-type--SECONDARY',
  [COLOR.tertiary]: 'om-type--TERTIARY',
  [COLOR.inverse]: 'om-type--INVERSE',
  [COLOR.success]: 'om-type--SUCCESS',
  [COLOR.warning]: 'om-type--WARNING'
};
export const DISPLAY_MODE = {
  block: 'block',
  initial: 'initial',
  inline: 'inline'
};
export const FONT_WEIGHT = {
  regular: 'regular',
  medium: 'medium',
  bold: 'bold'
};
export const FONT_WEIGHT_MAP = {
  [FONT_WEIGHT.regular]: 'om-type--REGULAR',
  [FONT_WEIGHT.medium]: 'om-type--MEDIUM',
  [FONT_WEIGHT.bold]: 'om-type--BOLD',
  [FONT_WEIGHT.black]: 'om-type--BLACK'
};
export const GUTTER_SPACING = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const TEXT_ALIGNMENT = {
  center: 'center',
  inherit: 'inherit',
  justify: 'justify',
  left: 'left',
  right: 'right'
};
export const TEXT_STYLE = {
  italic: 'italic'
};
export const TYPE = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  sh1: 'sh1',
  sh2: 'sh2',
  sh3: 'sh3',
  sh4: 'sh4',
  b1: 'b1',
  b2: 'b2',
  code1: 'code1',
  code2: 'code2',
  helper: 'helper'
};
export const HEADLINE_TYPE = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
  h5: 5,
  h6: 6,
  h7: 7,
  h8: 8,
  h9: 9,
  h10: 10
};
export const HEADLINE_TYPE_MAP = {
  [HEADLINE_TYPE.h1]: 'headline-01',
  [HEADLINE_TYPE.h2]: 'headline-02',
  [HEADLINE_TYPE.h3]: 'headline-03',
  [HEADLINE_TYPE.h4]: 'headline-04',
  [HEADLINE_TYPE.h5]: 'headline-05',
  [HEADLINE_TYPE.h6]: 'headline-06',
  [HEADLINE_TYPE.h7]: 'headline-07',
  [HEADLINE_TYPE.h8]: 'headline-08',
  [HEADLINE_TYPE.h9]: 'headline-09',
  [HEADLINE_TYPE.h10]: 'headline-10'
};
export const SUBHEADLINE_TYPE = {
  sh1: 1,
  sh2: 2,
  sh3: 3,
  sh4: 4
};
export const SUBHEADLINE_TYPE_MAP = {
  [SUBHEADLINE_TYPE.sh1]: 'subheadline-01',
  [SUBHEADLINE_TYPE.sh2]: 'subheadline-02',
  [SUBHEADLINE_TYPE.sh3]: 'subheadline-03',
  [SUBHEADLINE_TYPE.sh4]: 'subheadline-04'
};
export const BODY_TEXT_TYPE = {
  b1: 1,
  b2: 2,
  b3: 3
};
export const BODY_TEXT_TYPE_MAP = {
  [BODY_TEXT_TYPE.b1]: 'body-text-01',
  [BODY_TEXT_TYPE.b2]: 'body-text-02',
  [BODY_TEXT_TYPE.b3]: 'body-text-03'
};
export const CODE_TYPE = {
  c1: 1,
  c2: 2
};
export const CODE_TYPE_MAP = {
  [CODE_TYPE.c1]: 'code-01',
  [CODE_TYPE.c2]: 'code-02'
};
export const TYPE_MAPPING = {
  [TYPE.h1]: 'h1',
  [TYPE.h2]: 'h2',
  [TYPE.h3]: 'h3',
  [TYPE.h4]: 'h4',
  [TYPE.h5]: 'h5',
  [TYPE.sh1]: 'h6',
  [TYPE.sh2]: 'h6',
  [TYPE.sh3]: 'h6',
  [TYPE.sh4]: 'h6',
  [TYPE.b1]: 'p',
  [TYPE.b2]: 'p',
  [TYPE.code1]: 'p',
  [TYPE.code2]: 'p',
  [TYPE.helper]: 'span',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h1]]: 'h1',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h2]]: 'h2',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h3]]: 'h3',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h4]]: 'h4',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h5]]: 'h5',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h6]]: 'h6',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h7]]: 'p',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h8]]: 'p',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h9]]: 'p',
  [HEADLINE_TYPE_MAP[HEADLINE_TYPE.h10]]: 'p',
  [SUBHEADLINE_TYPE_MAP[SUBHEADLINE_TYPE.sh1]]: 'p',
  [SUBHEADLINE_TYPE_MAP[SUBHEADLINE_TYPE.sh2]]: 'p',
  [SUBHEADLINE_TYPE_MAP[SUBHEADLINE_TYPE.sh3]]: 'p',
  [SUBHEADLINE_TYPE_MAP[SUBHEADLINE_TYPE.sh4]]: 'p',
  [BODY_TEXT_TYPE_MAP[BODY_TEXT_TYPE.b1]]: 'p',
  [BODY_TEXT_TYPE_MAP[BODY_TEXT_TYPE.b2]]: 'p',
  [BODY_TEXT_TYPE_MAP[BODY_TEXT_TYPE.b3]]: 'p',
  [CODE_TYPE_MAP[CODE_TYPE.c1]]: 'p',
  [CODE_TYPE_MAP[CODE_TYPE.c2]]: 'p'
};
export default {
  COLOR,
  COLOR_MAP,
  DISPLAY_MODE,
  FONT_WEIGHT,
  FONT_WEIGHT_MAP,
  GUTTER_SPACING,
  TEXT_ALIGNMENT,
  TEXT_STYLE,
  TYPE,
  TYPE_MAPPING
};